
import { defineComponent, reactive, toRefs, h } from 'vue';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutation-types';
import DarwLots from '@/utils/draw_lots';
import Fate from '@/models/fate';
import FateResult from './FateResult.vue';

export default defineComponent({
  components: { FateResult },
  name: 'FateForm',
  setup() {
    const state = reactive(new Fate());
    const poem = reactive({
      poemImages: [] as string[],
    });
    const store = useStore();

    const createTask = () => {
      if (
        state.question === ''
      ) return;

      const darw = DarwLots.Exec(state.question);

      state.result = darw.result;
      poem.poemImages = darw.poemImages;
      const fate = new Fate({
        question: state.question,
        result: state.result,
        datetime: state.datetime,
      });

      store.commit(MutationTypes.SAVE_FATE, fate);
    };

    return { createTask, ...toRefs(state), ...toRefs(poem) };
  },
});
